import { BlackboardIcon } from './ResourceIcons/BlackboardIcon';
import { OasisIcon } from './ResourceIcons/OasisIcon';
import { GrammarlyIcon } from './ResourceIcons/GrammarlyIcon';
import { SoniaIcon } from './ResourceIcons/SoniaIcon';
import { BrandportalIcon } from './ResourceIcons/BrandPortalIcon';
import { StaffportalIcon } from './ResourceIcons/StaffportalIcon';
import { SupportIcon } from './ResourceIcons/SupportIcon';
import { IResourceIcon } from './ResourceIcons/ResourceIcon';

export interface ResourceConfig {
  id: string;
  title: string;
  description: string;
  ctaLabel: string;
  href: string;
  icon: IResourceIcon;
  searchTerms: string[];
  facets: string[];
}

export const RESOURCE_CONFIGS: Record<string, ResourceConfig> = {
  blackboard: {
    id: 'blackboard',
    title: 'Blackboard',
    description: 'Access your lecture notes, online assessments, discussion forums and more through Blackboard – Curtin’s learning management system.',
    ctaLabel: 'Launch',
    href: 'https://lms.curtin.edu.au',
    icon: BlackboardIcon,
    searchTerms: ['blackboard', 'black board', 'lms'],
    facets: ['all'],
  },
  oasis: {
    id: 'oasis',
    title: 'OASIS',
    description: 'Access key services, complete essential tasks, and stay connected to your studies through OASIS – your central student gateway at Curtin.',
    ctaLabel: 'Launch',
    href: 'https://oasis.curtin.edu.au/',
    icon: OasisIcon,
    searchTerms: ['oasis'],
    facets: ['all'],
  },
  grammarly: {
    id: 'grammarly',
    title: 'Grammarly',
    description: 'Learn how to access Grammarly via Blackboard and get writing support to help you with grammar, spelling and clarity in your assignments.',
    ctaLabel: 'Launch',
    href: 'https://students.connect.curtin.edu.au/app/faq/a_id/1976',
    icon: GrammarlyIcon,
    searchTerms: ['grammarly', 'garmerly', 'grammerly'],
    facets: ['all'],
  },
  sonia: {
    id: 'sonia',
    title: 'SONIA',
    description: 'Keep track of upcoming placements, access documentation and manage communication for your fieldwork.',
    ctaLabel: 'Launch',
    href: 'https://sonia.curtin.edu.au',
    icon: SoniaIcon,
    searchTerms: ['sonia'],
    facets: ['all'],
  },
  brandPortal: {
    id: 'brandPortal',
    title: 'Brand Portal',
    description: 'Learn how to apply the Curtin brand to your publications, advertisements or make a request.',
    ctaLabel: 'Launch',
    href: 'https://brand.curtin.edu.au/',
    icon: BrandportalIcon,
    searchTerms: ['brand', 'brand portal'],
    facets: ['all'],
  },
  staffPortal: {
    id: 'staffPortal',
    title: 'Staff Portal',
    description: 'Access key systems, policies, tools and updates for Curtin staff.',
    ctaLabel: 'Launch',
    href: 'https://staffportal.curtin.edu.au/',
    icon: StaffportalIcon,
    searchTerms: ['staff', 'staff portal'],
    facets: ['all'],
  },
  supportU: {
    id: 'supportU',
    title: 'SupportU',
    description: 'Get help and technical support for Curtin systems and applications, including account access, software and troubleshooting.',
    ctaLabel: 'Launch',
    href: 'https://supportu.curtin.edu.au/',
    icon: SupportIcon,
    searchTerms: ['supportu', 'support u'],
    facets: ['all'],
  },
};

// Helper to get all resource configs as an array
export const getAllResourceConfigs = (): ResourceConfig[] => {
  return Object.values(RESOURCE_CONFIGS);
};

// Helper to get a specific resource config by ID
export const getResourceConfig = (id: string): ResourceConfig | undefined => {
  return RESOURCE_CONFIGS[id];
};
